import { settingsApi } from '#entities';

import type { AppDispatch } from '#shared';

const REFETCH = { subscribe: false, forceRefetch: true } as const;

/**
 * Refetches both settings tiers. Run on every socket open, because a frame
 * missed while disconnected is never replayed. Best-effort: never throws.
 */
export const runSettingsRefetch = async (
  dispatch: AppDispatch,
): Promise<void> => {
  // A rejection is already in the RTK Query cache; allSettled only keeps it
  // out of `socket.onopen`.
  await Promise.allSettled([
    dispatch(
      settingsApi.endpoints.getGlobalSettings.initiate(undefined, REFETCH),
    ).unwrap(),
    dispatch(
      settingsApi.endpoints.getUserParameters.initiate(undefined, REFETCH),
    ).unwrap(),
  ]);
};
